import { useState, useEffect, useRef } from "react";
import { jwtFetch } from "./utils/apiClient";
import { format, parse } from "date-fns";
import { Tabs, Tab, Modal } from "react-bootstrap";
import { config, priceFormat } from "./Components/Config";
import Menu from "./Components/Menu";
import Header from "./Components/Header";

const Opportunity = () => {
  const [opportunities, setOpportunities] = useState(null);
  const [tableFilters, setTableFilters] = useState(null);
  const [tableSearch, setTableSearch] = useState('');
  const [tableSortBy, setTableSortBy] = useState('opportunity_code');
  const [tableSortType, setTableSortType] = useState('descending');
  const [isLoadingPage, setIsLoadingPage] = useState(true);
  const [showFilter, setShowFilter] = useState(false);
  const [filters, setFilters] = useState([{ field: '', value: '' }]);
  const [showImport, setShowImport] = useState(false);
  const [importData, setImportData] = useState(null);
  const crmUser = JSON.parse(localStorage.getItem('crmUser'));


  const searchInputRef = useRef(null);

  const csvHeaders = [
    { label: "Opty Created Date", key: "created_on" },
    { label: "Owner", key: "sales_name" },
    { label: "Expected Close Date", key: "opportunity_expected_closed" },
    { label: "Deal Status", key: "opportunity_status" },
    { label: "Deal Type", key: "opportunity_deal_type" },
    { label: "Company Name", key: "company_name" },
    { label: "Product Line", key: "opportunity_product_line" },
    { label: "Product Detail", key: "opportunity_product_detail" },
    { label: "Lead Source", key: "opportunity_source" },
    { label: "DR Number", key: "opportunity_registration" },
    { label: "Months", key: "opportunity_product_months" },
    { label: "Revenue/Contract", key: "opportunity_expected_revenue" },
    { label: "Profit/Contract", key: "opportunity_expected_profit" },
    { label: "Lead Number", key: "lead_id" },
  ];

  useEffect(() => {
    setTableFilters({
      opportunityStatus: 'Open',
    });
    getOpportunities();
  }, []);

  const getOpportunities = async () => {
    try {
      let requestOpportunity = {};
      const fetchOpportunities = await jwtFetch(config.ENDPOINT + 'get/opportunity', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestOpportunity)
      });
      let responseOpportunities = await fetchOpportunities.json();
      console.log(responseOpportunities);
      if (responseOpportunities.status === 200) {
        for (let i in responseOpportunities.data) {
          if (responseOpportunities.data[i].website_form) {
            const websiteForm = JSON.parse(responseOpportunities.data[i].website_form);
            responseOpportunities.data[i].company_name = websiteForm.company_name;
          }
          responseOpportunities.data[i].source_name = (responseOpportunities.data[i].source_name === 'Personal' || responseOpportunities.data[i].source_name === 'Principal') ? responseOpportunities.data[i].source_name : 'Marketing';
          let searchData = String(responseOpportunities.data[i].opportunity_code ?? '').toLowerCase();
          searchData += responseOpportunities.data[i].company_name ? responseOpportunities.data[i].company_name.toLowerCase() : '';
          searchData += responseOpportunities.data[i].company_billing_name ? responseOpportunities.data[i].company_billing_name.toLowerCase() : '';
          searchData += responseOpportunities.data[i].cperson_name ? responseOpportunities.data[i].cperson_name.toLowerCase() : '';
          searchData += responseOpportunities.data[i].cperson_email ? responseOpportunities.data[i].cperson_email.toLowerCase() : '';
          searchData += responseOpportunities.data[i].cperson_phone ? responseOpportunities.data[i].cperson_phone.toLowerCase() : '';
          searchData += responseOpportunities.data[i].opportunity_code ? responseOpportunities.data[i].opportunity_code.toLowerCase() : '';
          searchData += responseOpportunities.data[i].opportunity_status ? responseOpportunities.data[i].opportunity_status.toLowerCase() : '';
          searchData += responseOpportunities.data[i].opportunity_deal_type ? responseOpportunities.data[i].opportunity_deal_type.toLowerCase() : '';
          searchData += responseOpportunities.data[i].opportunity_product_line ? responseOpportunities.data[i].opportunity_product_line.toLowerCase() : '';
          searchData += responseOpportunities.data[i].opportunity_expected_closed ? responseOpportunities.data[i].opportunity_expected_closed.toLowerCase() : '';
          searchData += responseOpportunities.data[i].opportunity_expected_revenue ? responseOpportunities.data[i].opportunity_expected_revenue.toLowerCase() : '';
          searchData += responseOpportunities.data[i].opportunity_expected_profit ? responseOpportunities.data[i].opportunity_expected_profit.toLowerCase() : '';
          searchData += responseOpportunities.data[i].sales_name ? responseOpportunities.data[i].sales_name.toLowerCase() : '';
          searchData += responseOpportunities.data[i].source_name ? responseOpportunities.data[i].source_name.toLowerCase() : '';
          responseOpportunities.data[i].search = searchData;
        }
        setOpportunities(responseOpportunities.data);
        setIsLoadingPage(false);
      } else {
        alert(responseOpportunities.message);
      }
    } catch (error) {
      console.error('Error in getOpportunities:', error);
      alert('An error occurred: ' + (error.message || error));
    }
  }

  const filterTable = (key, value) => {
    let filters = { ...tableFilters };
    if (key === 'status') {
      filters.opportunityStatus = value;
    }
    setTableFilters(filters);
  }

  const sortTable = (sortBy) => {
    if (tableSortBy === sortBy) {
      setTableSortType(tableSortType === 'ascending' ? 'descending' : 'ascending');
    } else {
      setTableSortBy(sortBy);
      setTableSortType('ascending');
    }
  }

  const clearSearch = () => {
    setTableSearch('');
    if (searchInputRef.current) {
      searchInputRef.current.focus();
    }
  }

  const getStatusCount = (status) => {
    if (!opportunities) return 0;
    return opportunities.filter(opportunity =>
      opportunity.opportunity_status === status &&
      (tableSearch === '' || opportunity.search.includes(tableSearch.toLowerCase())) &&
      (filters.length === 0 || filters.every(filter => {
        if (!filter.field || !filter.value) return true;
        const fieldValue = opportunity[filter.field];
        if (fieldValue === null || fieldValue === undefined) return false;
        const fieldString = String(fieldValue).toLowerCase();
        const filterString = String(filter.value).toLowerCase();
        return fieldString.includes(filterString);
      }))
    ).length;
  }

  const changeFilter = (index, type, value) => {
    const updated = [...filters];
    updated[index][type] = value;
    setFilters(updated);
  }

  const addFilter = () => {
    const currentFilters = [...filters];
    currentFilters.push({ field: '', value: '' });
    setFilters(currentFilters);
  }

  const removeFilter = (index) => {
    const updated = [...filters];
    updated.splice(index, 1);
    setFilters(updated);
  }

  const resetFilter = () => {
    setFilters([{ field: '', value: '' }]);
  }

  const parseCSV = (text) => {
    const rows = [];
    let row = [];
    let field = '';
    let inQuotes = false;
    for (let i = 0; i < text.length; i++) {
      const char = text[i];
      if (char === '"') {
        if (inQuotes) {
          if (text[i + 1] === '"') {
            field += '"';
            i++;
          } else {
            inQuotes = false;
          }
        } else {
          inQuotes = true;
        }
      } else if (char === ',' && !inQuotes) {
        row.push(field.trim());
        field = '';
      } else if (char === '\n' || char === '\r') {
        if (inQuotes) {
          field += '\n';
        } else {
          row.push(field.trim());
          rows.push(row.map((val) => {
            if (val.length >= 2 && val.startsWith('"') && val.endsWith('"')) {
              return val.slice(1, -1);
            }
            return val;
          }));
          row = [];
          field = '';
          if (char === '\r' && text[i + 1] === '\n') {
            i++;
          }
        }
      } else {
        field += char;
      }
    }
    if (field.length > 0 || row.length > 0) {
      row.push(field.trim());
      rows.push(row.map((val) => {
        if (val.length >= 2 && val.startsWith('"') && val.endsWith('"')) {
          return val.slice(1, -1);
        }
        return val;
      }));
    }
    return rows;
  };

  const uploadCsv = (file) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const text = e.target.result;
      const rows = parseCSV(text);
      if (!rows || rows.length === 0) {
        setImportData([]);
        return;
      }
      const uploadedHeaders = rows[0].map(h => h.trim());
      const data = [];

      for (let i = 1; i < rows.length; i++) {
        const currentline = rows[i];
        if (!currentline || currentline.length === 0 || (currentline.length === 1 && currentline[0] === '')) continue;
        const obj = {};
        for (let j = 0; j < uploadedHeaders.length; j++) {
          const headerLabel = uploadedHeaders[j];
          const headerMapping = csvHeaders.find(h => h.label === headerLabel);
          if (headerMapping) {
            let value = currentline[j] ? currentline[j].trim() : '';
            if (headerMapping.key === 'created_on') {
              console.log(value);
              const parsed = parse(value, 'yyyy-MM-dd', new Date());
              value = format(parsed, 'yyyy-MM-dd HH:mm:ss');
            }
            obj[headerMapping.key] = value;
          }
        }
        if (!obj.deal_type) {
          obj.deal_type = obj.deal_type_init || 'New Business';
        }
        delete obj.deal_type_init;

        data.push(obj);
      }
      setImportData(data);
    };
    reader.readAsText(file);
  };

  const importOpportunity = async () => {
    try {
      setIsLoadingPage(true);
      if (!importData) {
        alert('Updated CSV file is required');
        setIsLoadingPage(false);
        return;
      }
      const requestImport = {
        opportunities: importData
      };
      const fetchImport = await jwtFetch(config.ENDPOINT + 'create/opportunity', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestImport)
      });
      const responseImport = await fetchImport.json();
      if (responseImport.status === 200) {
        window.location.reload();
      } else {
        setIsLoadingPage(false);
        alert(responseImport.message);
      }
    } catch (error) {
      console.error('Error in importOpportunity:', error);
      alert('An error occurred: ' + (error.message || error));
      setIsLoadingPage(false);
    }
  }

  return (
    <div id="opportunity-list">
      <div className="container-fluid p-0">
        <div className="row g-0 mh-100vh">
          <div className="col-md-2 border-end">
            <div className="d-md-flex d-none align-items-center justify-content-center p-1 h-48">
              <a className="h-100" href="/dashboard"><img className="h-100" src="/cuancuan.png" alt="PointStar" /></a>
            </div>
            <hr className="m-0" />
            <Menu active="opportunity" />
          </div>
          <div className="col-md-10">
            <Header />
            <hr className="m-0" />
            <div className="main">
              <div className="p-4">

                <section className="mb-4">
                  <div className="d-flex align-items-center justify-content-between mb-3">
                    <div className="d-flex align-items-center justify-content-between gap-4">
                      <div className="fs-24">Opportunity List</div>
                    </div>
                    <div className="d-flex align-items-center justify-content-between gap-2">
                      <div className="input-group input-search">
                        <button className="btn bg-white" type="button" onClick={() => clearSearch()}>{tableSearch ? <i className="bi bi-x-lg" /> : <i className="bi bi-search" />}</button>
                        <input className="form-control" type="text" placeholder="Search" value={tableSearch} onChange={(e) => setTableSearch(e.target.value.trim())} ref={searchInputRef} autoFocus />
                      </div>
                      <button className="btn btn-outline-secondary" type="button" onClick={() => setShowFilter(true)}><i className="bi bi-filter me-1" /> Filter {filters.filter(f => f.field && f.value).length > 0 ? `(${filters.filter(f => f.field && f.value).length})` : ''}</button>
                      {crmUser.user_department !== 'Marketing' && crmUser.user_level !== 'View' && (
                        <>
                          <button className="btn btn-link bg-gold" type="button" onClick={() => window.location.href = '/opportunity/add'} target="_blank" rel="noreferrer"><i className="bi bi-plus-circle me-1" /> Add</button>
                          <button className="btn btn-link bg-gold" type="button" onClick={() => setShowImport(true)}><i className="bi bi-upload me-1" /> Import</button>
                        </>
                      )}

                    </div>
                  </div>
                  <div className="bg-white border-radius-4 p-4">
                    <Tabs className="mb-3" defaultActiveKey="Open" onSelect={(key) => filterTable('status', key)}>
                      <Tab eventKey="Open" title={`Open${getStatusCount('Open') > 0 ? ` (${getStatusCount('Open')})` : ''}`} />
                      <Tab eventKey="Opportunity" title={`Opportunity${getStatusCount('Opportunity') > 0 ? ` (${getStatusCount('Opportunity')})` : ''}`} />
                      <Tab eventKey="Won" title={`Won${getStatusCount('Won') > 0 ? ` (${getStatusCount('Won')})` : ''}`} />
                      <Tab eventKey="On Hold" title={`On Hold${getStatusCount('On Hold') > 0 ? ` (${getStatusCount('On Hold')})` : ''}`} />
                      <Tab eventKey="Lost" title={`Lost${getStatusCount('Lost') > 0 ? ` (${getStatusCount('Lost')})` : ''}`} />
                    </Tabs>
                    {opportunities && opportunities.length > 0 ? (
                      <div className="table-responsive">
                        <table className="table table-hover">
                          <thead>
                            <tr>
                              <th className="bg-gold w-40">#</th>
                              {/* <th className="bg-gold w-140 pointer" onClick={() => sortTable('opportunity_code')}>Number {tableSortBy === 'opportunity_code' && (tableSortType === 'ascending' ? <span className="bi bi-sort-down-alt ms-2"/> : <span className="bi bi-sort-up-alt ms-2"/>)}</th> */}
                              <th className="bg-gold w-150 pointer text-start" onClick={() => sortTable('company_name')}>Company Name {tableSortBy === 'company_name' && (tableSortType === 'ascending' ? <span className="bi bi-sort-down-alt ms-2" /> : <span className="bi bi-sort-up-alt ms-2" />)}</th>
                              <th className="bg-gold w-125 pointer text-start" onClick={() => sortTable('opportunity_deal_type')}>Deal Type {tableSortBy === 'opportunity_deal_type' && (tableSortType === 'ascending' ? <span className="bi bi-sort-down-alt ms-2" /> : <span className="bi bi-sort-up-alt ms-2" />)}</th>
                              <th className="bg-gold w-125 pointer text-start" onClick={() => sortTable('opportunity_product_line')}>Product Line {tableSortBy === 'opportunity_product_line' && (tableSortType === 'ascending' ? <span className="bi bi-sort-down-alt ms-2" /> : <span className="bi bi-sort-up-alt ms-2" />)}</th>
                              <th className="bg-gold w-125 pointer text-start" onClick={() => sortTable('opportunity_product_detail')}>Product Details {tableSortBy === 'opportunity_product_detail' && (tableSortType === 'ascending' ? <span className="bi bi-sort-down-alt ms-2" /> : <span className="bi bi-sort-up-alt ms-2" />)}</th>
                              {/* <th className="bg-gold pointer" onClick={() => sortTable('opportunity_expected_closed')}>Expected Closing Date {tableSortBy === 'opportunity_expected_closed' && (tableSortType === 'ascending' ? <span className="bi bi-sort-down-alt ms-2"/> : <span className="bi bi-sort-up-alt ms-2"/>)}</th> */}
                              <th className="bg-gold w-125 pointer text-end" onClick={() => sortTable('opportunity_expected_revenue')}>Estimated Revenue {tableSortBy === 'opportunity_expected_revenue' && (tableSortType === 'ascending' ? <span className="bi bi-sort-down-alt ms-2" /> : <span className="bi bi-sort-up-alt ms-2" />)}</th>
                              <th className="bg-gold w-125 pointer text-end" onClick={() => sortTable('opportunity_expected_profit')}>Estimated Profit {tableSortBy === 'opportunity_expected_profit' && (tableSortType === 'ascending' ? <span className="bi bi-sort-down-alt ms-2" /> : <span className="bi bi-sort-up-alt ms-2" />)}</th>
                              {/* <th className="bg-gold pointer" onClick={() => sortTable('lead_enquiry')}>Enquiry {tableSortBy === 'lead_enquiry' && (tableSortType === 'ascending' ? <span className="bi bi-sort-down-alt ms-2"/> : <span className="bi bi-sort-up-alt ms-2"/>)}</th>
                              <th className="bg-gold w-105 pointer" onClick={() => sortTable('opportunity_source')}>Source {tableSortBy === 'opportunity_source' && (tableSortType === 'ascending' ? <span className="bi bi-sort-down-alt ms-2"/> : <span className="bi bi-sort-up-alt ms-2"/>)}</th> */}
                              <th className="bg-gold w-80 pointer text-start" onClick={() => sortTable('open_for')}>Open for {tableSortBy === 'open_for' && (tableSortType === 'ascending' ? <span className="bi bi-sort-down-alt ms-2" /> : <span className="bi bi-sort-up-alt ms-2" />)}</th>
                              <th className="bg-gold w-150 pointer text-start" onClick={() => sortTable('sales_name')}>Sales Name {tableSortBy === 'sales_name' && (tableSortType === 'ascending' ? <span className="bi bi-sort-down-alt ms-2" /> : <span className="bi bi-sort-up-alt ms-2" />)}</th>
                              <th className="bg-gold w-40"></th>
                            </tr>
                          </thead>
                          <tbody>
                            {[...opportunities]
                              .sort((a, b) => {
                                const aValue = a[tableSortBy];
                                const bValue = b[tableSortBy];
                                const aNum = Number(aValue);
                                const bNum = Number(bValue);
                                const isNumeric = !isNaN(aNum) && !isNaN(bNum);
                                if (isNumeric) {
                                  return tableSortType === 'ascending' ? aNum - bNum : bNum - aNum;
                                }
                                return tableSortType === 'ascending'
                                  ? (aValue ?? '').toString().localeCompare((bValue ?? '').toString())
                                  : (bValue ?? '').toString().localeCompare((aValue ?? '').toString());
                              })
                              .filter(opportunity => opportunity.search.includes(tableSearch.toLowerCase()))
                              .filter(opportunity => {
                                if (tableFilters && tableFilters.opportunityStatus) {
                                  return opportunity.opportunity_status === tableFilters.opportunityStatus;
                                }
                                return true;
                              })
                              .filter(opportunity => {
                                if (filters && filters.length > 0) {
                                  return filters.every(filter => {
                                    if (!filter.field || !filter.value) return true;
                                    const fieldValue = opportunity[filter.field];
                                    if (fieldValue === null || fieldValue === undefined) return false;
                                    const fieldString = String(fieldValue).toLowerCase();
                                    const filterString = String(filter.value).toLowerCase();
                                    return fieldString.includes(filterString);
                                  });
                                }
                                return true;
                              })
                              .map((opportunity, q) => (
                                <tr key={"opportunity-" + q}>
                                  <td valign="middle" align="center">{q + 1}</td>
                                  {/* <td valign="middle" align="center">{opportunity.opportunity_code}</td> */}
                                  <td valign="middle"><strong>{opportunity.company_name}</strong></td>
                                  <td valign="middle">{opportunity.opportunity_deal_type}</td>
                                  <td valign="middle">{opportunity.opportunity_product_line}</td>
                                  <td valign="middle">
                                    <strong>{opportunity.opportunity_product_detail}</strong>
                                    <br />
                                    <small>{opportunity.opportunity_remarks}</small>
                                  </td>
                                  {/* <td valign="middle" align="center">{format(opportunity.opportunity_expected_closed, 'd MMM yyyy')}</td> */}
                                  <td valign="middle" align="right">{priceFormat(opportunity.opportunity_expected_revenue, 'IDR')}</td>
                                  <td valign="middle" align="right">{priceFormat(opportunity.opportunity_expected_profit, 'IDR')}</td>
                                  {/* <td valign="middle" align="center">{opportunity.lead_enquiry}</td>
                                <td valign="middle" align="center">{opportunity.opportunity_source}</td> */}
                                  <td valign="middle">{opportunity.open_for}</td>
                                  <td valign="middle">
                                    <span>{opportunity.sales_name}</span>
                                    <br />
                                    <small>created on {format(opportunity.created_on, 'd MMM yyyy')}</small>
                                  </td>
                                  <td valign="middle" align="right"><a className="btn btn-sm bg-gold" href={'/opportunity/detail/' + opportunity.id_opportunity}><i className="bi bi-eye" /></a></td>
                                </tr>
                              ))}
                          </tbody>
                        </table>
                      </div>
                    ) : (
                      <p>{isLoadingPage ? 'Loading...' : 'No data'}</p>
                    )}
                  </div>
                </section>

                <Modal show={showFilter} onHide={() => setShowFilter(false)}>
                  <Modal.Header closeButton>
                    <Modal.Title>Filter Table</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    {filters.map((filter, f) => {
                      return (
                        <div className="row align-items-baseline form-group mb-2 g-2" key={"filter-" + f}>
                          <div className="col-md-4">
                            <select className="form-select" value={filter.field} onChange={(e) => changeFilter(f, 'field', e.target.value)} required>
                              <option value=""></option>
                              <option value="opportunity_code">Number</option>
                              <option value="company_name">Company Name</option>
                              <option value="opportunity_product_line">Product Line</option>
                              <option value="opportunity_deal_type">Deal Type</option>
                              <option value="opportunity_source">Source</option>
                              <option value="sales_name">Sales Name</option>
                            </select>
                          </div>
                          <div className="col-md-7">
                            <input className="form-control" type="text" value={filter.value} onChange={(e) => changeFilter(f, 'value', e.target.value)} required />
                          </div>
                          <div className="col-md-1">
                            <button className="btn btn-sm btn-link" onClick={() => removeFilter(f)}><i className="bi bi-dash-lg"></i></button>
                          </div>
                        </div>
                      );
                    })}
                    <div className="d-flex justify-content-between">
                      <button className="btn btn-outline-secondary" type="button" onClick={() => addFilter()} disabled={isLoadingPage}>Add Filter</button>
                      <button className="btn btn-link" type="button" onClick={() => resetFilter()} disabled={isLoadingPage}>Reset</button>
                    </div>
                  </Modal.Body>
                </Modal>

                <Modal show={showImport} onHide={() => setShowImport(false)}>
                  <Modal.Header closeButton>
                    <Modal.Title>Opportunity Import</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <div className="row align-items-baseline form-group mb-2">
                      <div className="col-md-4">
                        <label>Upload CSV<span className="text-danger">*</span></label>
                      </div>
                      <div className="col-md-8">
                        <input className="form-control" type="file" placeholder="Upload file" accept=".csv" onChange={(e) => uploadCsv(e.target.files[0])} required />
                      </div>
                    </div>
                    <div className="d-flex justify-content-end">
                      <button className="btn btn-link" type="button" onClick={() => setShowImport(false)} disabled={isLoadingPage}>Cancel</button>
                      <button className="btn btn-link bg-gold" type="button" onClick={() => importOpportunity()} disabled={isLoadingPage}>Import</button>
                    </div>
                  </Modal.Body>
                </Modal>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Opportunity;

